import { connect } from 'react-redux';
import IAppState from "./IAppState";
import Actions from "./act-main";
import { IPageComponentPropsData, IPageComponentPropsFunctions } from './IPageComponentProps';
import PageComponent from './PageComponent';
import { ll_fetch } from './tools';

const mapStateToProps = (state: IAppState): IPageComponentPropsData => ({
    appState: state,
})

const mapDispatchToProps = (dispatch): IPageComponentPropsFunctions => ({
    setAppState: (appState: IAppState) => dispatch(Actions.setAppState(appState)),
    setInitialInputState: () => dispatch(Actions.setInitialInputState()),
})

const validateSession = (session) => {
    // check if your session is still valid
    return true;
  }

const PageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PageComponent);

export default PageContainer;
